<script>
  // your script goes here
</script>

<h3>Custom Sublimation Printing</h3>
<div class="feature">
  <div class="icon">
    <img src="img/icons/shipped.svg" alt="shipping" />
  </div>
  <div class="text">
    <p>3 Week Delivery</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/shirt.svg" alt="tshirt" />
  </div>
  <div class="text">
    <p>Fully Custom Design or Edit a Template</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/fabric-printed.svg" alt="print" />
  </div>
  <div class="text">
    <p>Print Dyed Directly into Fabric</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/muscle.svg" alt="strong" />
  </div>
  <div class="text">
    <p>Durable and Flexible</p>
  </div>
</div>
<div class="feature">
  <div class="icon">
    <img src="img/icons/membrane.svg" alt="coolmesh" />
  </div>
  <div class="text">
    <p>100% CoolDry Polyester</p>
  </div>
</div>

<style>
  h3 {
    color: #1b285d;
    text-transform: uppercase;
    line-height: 4rem;
    padding-top: 2rem;
  }

  .feature {
    display: flex;
    align-self: flex-start;
    align-items: center;
    margin-top: 2rem;
    margin-left: 4rem;
  }

  .icon {
    background: #fe5900;
    padding: 0.4rem;
    border-radius: 5px;
    margin-right: 1rem;
  }

  img {
    width: 4rem;
    height: 4rem;
  }

  .text {
    font-size: 1.6rem;
    font-weight: 600;
    color: #464646;
  }
</style>
